<template>
  <v-dialog v-model="dialog" persistent width="800">
    <v-card>
      <v-card-title class="py-5">
        <span class="font-28 w-600 text-00A99D pl-3">Export Excel</span>
        <v-spacer></v-spacer>
        <v-btn icon color="#00A99D" @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text>
        <v-row class="my-5">
          <v-col cols="12" lg="6" md="6" sm="6" align="center">
            <v-date-picker v-model="day_select" no-title range locale="th" color="#00A99D" />
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="6" align="center">
            <v-row>
              <v-col cols="12" align="start" class="pt-5 pb-0">
                <span class="font-16 w-600 text-navy-50">ครั้งที่นัดหมาย</span>
                <v-text-field 
                  v-model="appointment_no" 
                  dense 
                  solo 
                  hide-details="auto" 
                  append-icon="mdi-magnify" 
                  clearable 
                  clear-icon="mdi-close-circle"
                  color="#00A99D">
                  <template slot="label">
                    <span class="font-14">กรุณากรอกครั้งที่นัดหมาย</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" align="start" class="pb-0">
                <span class="font-16 w-600 text-navy-50">ทีมแพทย์</span>
                <v-select 
                  class="pt-1"
                  hide-details="auto"
                  solo 
                  dense 
                  append-icon="mdi-chevron-down"
                  :menu-props="{ bottom: true, offsetY: true }" 
                  clearable
                  @click:clear="doctor = ''" 
                  clear-icon="mdi-close-circle"
                  v-model="doctor"
                  :items="doctor_list"
                  item-text="title"
                  item-value="detail.one_id"
                  color="#00A99D" 
                  item-color="teal darken-2"
                  >
                  <template slot="append">
                    <v-btn text icon>
                      <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>

                  <template slot="label">
                    <span class="font-14">ทีมแพทย์ทั้งหมด</span>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" align="start" class="pb-0">
                <span class="font-16 w-600 text-navy-50">สถานะการเยี่ยมบ้าน</span>
                <v-select class="pt-1" hide-details="auto" solo dense placeholder="สถานะทั้งหมด" append-icon="mdi-chevron-down"
                  :menu-props="{ bottom: true, offsetY: true }" v-model="selectStatus"
                  :items="status" item-text="name" item-value="id"
                  color="#00A99D" item-color="teal darken-2">
                  <template slot="append">
                    <v-btn text icon>
                      <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" align="start" class="pb-0">
                <span class="font-16 w-600 text-navy-50">ความเร่งด่วน</span>
                <v-select class="pt-1" hide-details="auto" solo dense placeholder="สถานะทั้งหมด" append-icon="mdi-chevron-down"
                  :menu-props="{ bottom: true, offsetY: true }" v-model="select_urgency"
                  :items="urgency_list" item-text="text" item-value="value"
                  color="#00A99D" item-color="teal darken-2">
                  <template slot="append">
                    <v-btn text icon>
                      <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" align="center" class="pb-0">
                <v-text-field v-model="dateRangeText" class="center" :value="displayDate()" label="ภายในช่วงเวลา" readonly color="#00A99D" style="text-align-last: center;">
                  <template v-slot:prepend>
                    <v-icon color="#00A99D" class="mb-2" size="24">mdi-calendar</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" align="center" class="pb-0">
                <v-btn depressed color="#00A99D" style="border-radius: 20px 5px;" width="150px" class="px-2 ml-2 py-5" :loading="btn_loading" @click="exportExcel()"
                  :disabled="day_select.length == 0">
                  <v-icon color="#ffffff" style="text-transform: capitalize;">mdi-tray-arrow-down</v-icon>
                  <span class="pl-1 text-white" style="text-transform: capitalize;">Export File</span>
                  <template v-slot:loader>
                    <span class="text-white">ดาวน์โหลด...</span>
                  </template>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
  
</template>

<script>
import moment from "moment";
import XLSX from "xlsx-js-style";
import functioncryto from "@/services/encrypt.js";

export default {
  data() {
    return {
      dialog: false,
      start_date: '',
      end_date: '',
      day_select: [],
      doctor: '',
      doctor_list: [],
      status: [
        {
          id: '',
          name: 'สถานะทั้งหมด'
        },
        {
          id: 1,
          name: 'รอเยี่ยมบ้าน'
        },
        {
          id: 2,
          name: 'กำลังดำเนินการ'
        },
        {
          id: 3,
          name: 'เสร็จสิ้น'
        },
        {
          id: 4,
          name: 'ยกเลิก'
        }
      ],
      selectStatus: '',
      btn_loading: false,
      select_urgency: "",
      appointment_no: "",
      urgency_list: [
        { id: 0, text: 'ความเร่งด่วนทั้งหมด', value: "" },
        { id: 1, text: 'เร่งด่วนปกติ', value: "1" },
        { id: 2, text: 'เร่งด่วนปานกลาง', value: "2" },
        { id: 3, text: 'เร่งด่วนมาก', value: "3" },
      ],
    }
  },
  computed: {
    dateRangeText() {
      if(this.day_select.length == 0) {
        return ''
      } else {
        var start_year1 = ""
        var start_year2 = ""
        var end_year1 = ""
        var end_year2 = ""
        if (this.start_date > this.end_date) {
          start_year1 = moment(this.start_date).locale("th").format("YYYY")
          start_year2 = (parseInt(start_year1) + 543).toString()
          end_year1 = moment(this.end_year).locale("th").format("YYYY")
          end_year2 = (parseInt(end_year1) + 543).toString()
          return  moment(this.end_date).locale("th").format("D MMMM " + end_year2)
                  +" ~ "
                  + moment(this.start_date).locale("th").format("D MMMM " + start_year2)
        } else if (this.start_date == this.end_date) {
          start_year1 = moment(this.start_date).locale("th").format("YYYY")
          start_year2 = (parseInt(start_year1) + 543).toString()
          return moment(this.start_date).locale("th").format("D MMMM " + start_year2)
        } else if (!this.end_date) {
          start_year1 = moment(this.start_date).locale("th").format("YYYY")
          start_year2 = (parseInt(start_year1) + 543).toString()
          return moment(this.start_date).locale("th").format("D MMMM " + start_year2)
        } else {
          start_year1 = moment(this.start_date).locale("th").format("YYYY")
          start_year2 = (parseInt(start_year1) + 543).toString()
          end_year1 = moment(this.end_year).locale("th").format("YYYY")
          end_year2 = (parseInt(end_year1) + 543).toString()
          return  moment(this.start_date).locale("th").format("D MMMM " + start_year2)
                  +" ~ "
                  + moment(this.end_date).locale("th").format("D MMMM" + end_year2)
        }
      }
    },
  },
  methods: {
    async openDialog() {
      this.doctor = ''
      await this.getDoctor()
      this.dialog = true
      
    },
    closeDialog() {
      this.start_date = ''
      this.end_date = ''
      this.day_select = []
      this.selectStatus = ''
      this.btn_loading = false
      this.select_urgency = ""
      this.appointment_no = ""
      this.doctor = ''
      this.doctor_list = []
      this.dialog = false
    },
    displayDate() {
      if (!this.day_select) return ''
      return (
        (this.start_date = this.day_select[0]),
        (this.end_date = this.day_select[1])
      );
    },
    exportExcel() {
      this.btn_loading = true
      setTimeout(async () => {
        await this.export()
        this.btn_loading = false
      }, 500)
      
      console.log('date :', this.day_select);
      console.log('selectStatus :', this.selectStatus || '0');
    },
    convertDate(time = "") {
      var year1 = ""
      var year2 = ""
      year1 = moment(time).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(time).locale("th").format("DD/MM/" + year2);
    },
    showDateHeader() {
      var start_year1 = ""
      var start_year2 = ""
      var end_year1 = ""
      var end_year2 = ""
      if (this.start_date > this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_date).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return moment(this.end_date).locale("th").format("D MMMM " + end_year2)
              + " - "
              + moment(this.start_date).locale("th").format("D MMMM " + start_year2)
      } else if (!this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM " + start_year2)
      } else {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_date).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM " + start_year2) 
               + " - "
               + moment(this.end_date).locale("th").format("D MMMM " + end_year2) 
      }
    },
    showDate(item) {
      if (item !== '' && item !== null && item !== undefined) {
        var year1 = ""
        var year2 = ""
        year1 = moment(item).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(item).locale("th").format("DD/MM/" + year2)
      } else {
        return '-'
      }
    },
    showDateSlot(item) {
      if (item.slot_date !== '' && item.slot_date !== null && item.slot_date !== undefined) {
        var year1 = ""
        var year2 = ""
        year1 = moment(item.slot_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return 'วันที่ ' + moment(item.slot_date).locale("th").format("DD/MM/" + year2) + ' เวลา ' + item.start_time + ' - '+  item.end_time + ' น.'
      } else {
        return '-'
      }
    },
    showDateTime(item) {
      if (item !== '' && item !== null && item !== undefined) {
        var year1 = ""
        var year2 = ""
        year1 = moment(item).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return 'วันที่ ' + moment(item).locale("th").format("DD/MM/" + year2) + ' เวลา ' + moment(item).locale("TH").format("LT") + ' น.'
      } else {
        return '-'
      }
    },
    showOld(item) {
      if (item !== '' && item !== null && item !== undefined) {
        const y = Math.floor(moment.duration(moment().diff(item)).asYears());
        if (y > 0) {
          return y + ' ปี'
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    showFormList(item) {
      if (item.form_list.length !== 0) {
        var status = ''
        var data = ''
        item.form_list.forEach((value, index) => {
          if (value.status == 'wait') {
            status = 'กำลังดำเนินการ'
          } else if (value.status == 'success') {
            status = 'เสร็จสิ้น'
          } else if (value.status == 'cancel') {
            status = 'ยกเลิก'
          }
          
          if (index == (item.form_list.length - 1)) {
            if (value.template_id !== '' && value.template_id !== null && value.template_id !== undefined) {
              data += 'เลขที่อ้างอิงเอกสาร: ' + value.template_id
            } 

            if (value.form_name !== '' && value.form_name !== null && value.form_name !== undefined) {
              data += ' ชื่อเอกสาร: ' + value.form_name
            }

            if (status !== '' && status !== null && status !== undefined) {
              data += ' สถานะ: ' + status
            }
          } else {
            if (value.template_id !== '' && value.template_id !== null && value.template_id !== undefined) {
              data += 'เลขที่อ้างอิงเอกสาร: ' + value.template_id
            } 

            if (value.form_name !== '' && value.form_name !== null && value.form_name !== undefined) {
              data += ' ชื่อเอกสาร: ' + value.form_name
            }

            if (status !== '' && status !== null && status !== undefined) {
              data += ' สถานะ: ' + status
            }

            data += ' , '
          }
        })

        if (data) {
          return data
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    showCID(item) {
      const maskedDigits = "X".repeat(6);
      const visibleDigits = functioncryto.decrypt(item).substring(6);
      return maskedDigits + visibleDigits;
    },
    async getDoctor() {
      const params = new URLSearchParams();
      params.append("biz_id", sessionStorage.biz_id)

      try {
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/doctor_nurse?${params}`).then((res) => {
          // console.log(res);
          if(res.data.result == 'success') {
            for(var x in res.data.data) {
              if (res.data.data[x].role == "แพทย์"){
                this.doctor_list.push(
                  {
                    title: `คุณหมอ ${res.data.data[x].staff_first_name_th} ${res.data.data[x].staff_last_name_th}`,
                    detail: {
                      name: `คุณหมอ ${res.data.data[x].staff_first_name_th} ${res.data.data[x].staff_last_name_th}`,
                      one_id: res.data.data[x].one_id
                    }
                  }
                )
              }else{
                let title = "พยาบาล"
                if (res.data.data[x].gender == "ชาย"){
                  title = "บุรุษพยาบาล"
                }
                this.doctor_list.push(
                  {
                    title: `${title} ${res.data.data[x].staff_first_name_th} ${res.data.data[x].staff_last_name_th}`,
                    detail: {
                      name: `${title} ${res.data.data[x].staff_first_name_th} ${res.data.data[x].staff_last_name_th}`,
                      one_id: res.data.data[x].one_id
                    }
                  }
                )
              }
            }
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async export() {
      try {
        var params = new URLSearchParams()
        params.append('biz_id', sessionStorage.getItem('biz_id'))
        params.append('status', this.selectStatus)
        params.append('urgency', this.select_urgency)
        params.append('doctor_id', this.doctor || '')
        params.append('appointment_no', this.appointment_no || '')

        if (this.start_date > this.end_date) {
          params.append("start_date", this.end_date || '');
          if (this.end_date) {
            params.append("end_date", this.start_date || '');
          }
        } else {
          params.append("start_date", this.start_date || '');
          if (this.end_date) {
            params.append("end_date", this.end_date || '');
          }
        }

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_home_visits?${params}`,
          ).then(async (res) => {
            if (res.data.result == "success") {
              this.dataExport = res.data.data.data
              console.log('res Home VisitList export', res);
              var safe = this;
              var title = [
                {
                  key:
                    "ประวัติการเยี่ยมบ้าน" + sessionStorage.getItem('biz_name') + " วันที่ " + this.showDateHeader()
                },
              ];
              var header = [
                {
                  key1: "ลำดับ",
                },
              ];
              var wscols = [
                { wch: 10 }
              ];

              // set header xlsx =================================================================================
              // HN
              header[0][`key${Object.keys(header[0]).length + 1}`] = "HN";
              wscols.push({ wch: 20 })

              // cid
              header[0][`key${Object.keys(header[0]).length + 1}`] = "หมายเลขบัตรประชาชน";
              wscols.push({ wch: 20 })

              // fullname
              header[0][`key${Object.keys(header[0]).length + 1}`] = "ชื่อผู้ใช้บริการ";
              wscols.push({ wch: 40 })

              // gender
              header[0][`key${Object.keys(header[0]).length + 1}`] = "เพศ";
              wscols.push({ wch: 20 })

              // birth_date
              header[0][`key${Object.keys(header[0]).length + 1}`] = "วัน/เดือน/ปีเกิด";
              wscols.push({ wch: 20 })

              // old
              header[0][`key${Object.keys(header[0]).length + 1}`] = "อายุ";
              wscols.push({ wch: 20 })

              // created_at
              header[0][`key${Object.keys(header[0]).length + 1}`] = "วันที่สร้าง";
              wscols.push({ wch: 40 })

              // slot_date
              header[0][`key${Object.keys(header[0]).length + 1}`] = "วันที่นัดหมาย";
              wscols.push({ wch: 40 })

              // appointment_no
              header[0][`key${Object.keys(header[0]).length + 1}`] = "ครั้งที่นัดหมาย";
              wscols.push({ wch: 20 })

              // doctor_name
              header[0][`key${Object.keys(header[0]).length + 1}`] = "ทีมแพทย์";
              wscols.push({ wch: 40 })

              // target_group
              header[0][`key${Object.keys(header[0]).length + 1}`] = "กลุ่มเป้าหมาย";
              wscols.push({ wch: 30 })

              // urgency
              header[0][`key${Object.keys(header[0]).length + 1}`] = "ความเร่งด่วน";
              wscols.push({ wch: 20 })

              // note_doctor
              header[0][`key${Object.keys(header[0]).length + 1}`] = "หมายเหตุการนัดหมาย";
              wscols.push({ wch: 30 })

              // status
              header[0][`key${Object.keys(header[0]).length + 1}`] = "สถานะ";
              wscols.push({ wch: 20 })

              // note
              header[0][`key${Object.keys(header[0]).length + 1}`] = "หมายเหตุยกเลิกนัดหมาย";
              wscols.push({ wch: 30 })

              // form_list
              header[0][`key${Object.keys(header[0]).length + 1}`] = "รายละเอียดแบบฟอร์ม";
              wscols.push({ wch: 80 })

              // =================================================================================================

              var table_body = [];
              this.dataExport.forEach((ele, index) => {

                var dataJson = {}

                // NO
                dataJson["NO"] = index + 1

                // HN
                if (Object.values(header[0]).indexOf('HN') != -1) {
                  dataJson["HN"] = 'HN' in ele && ele.HN != '' && ele.HN != null && ele.HN != undefined ? ele.HN : '-'
                }

                // cid
                if (Object.values(header[0]).indexOf('หมายเลขบัตรประชาชน') != -1) {
                  dataJson["cid"] = 'cid' in ele && ele.cid != '' && ele.cid != null && ele.cid != undefined ? this.showCID(ele.cid) : '-'
                }

                // fullname
                if (Object.values(header[0]).indexOf('ชื่อผู้ใช้บริการ') != -1) {
                  dataJson["fullname"] = 'fullname' in ele && ele.fullname !== '' && ele.fullname !== null && ele.fullname !== undefined ? ele.fullname : '-'
                }

                // gender
                if (Object.values(header[0]).indexOf('เพศ') != -1) {
                  dataJson["gender"] = 'gender' in ele && ele.gender !== '' && ele.gender !== null && ele.gender !== undefined ? ele.gender : '-'
                }

                // birth_date
                if (Object.values(header[0]).indexOf('วัน/เดือน/ปีเกิด') != -1) {
                  dataJson["birth_date"] = this.showDate(ele.birth_date)
                }

                // old
                if (Object.values(header[0]).indexOf('อายุ') != -1) {
                  dataJson["old"] = this.showOld(ele.birth_date)
                }

                // created_at
                if (Object.values(header[0]).indexOf('วันที่สร้าง') != -1) {
                  dataJson["created_at"] = this.showDateTime(ele.created_at)
                }

                // slot_date
                if (Object.values(header[0]).indexOf('วันที่นัดหมาย') != -1) {
                  dataJson["slot_date"] = this.showDateSlot(ele)
                }

                // appointment_no
                if (Object.values(header[0]).indexOf('ครั้งที่นัดหมาย') != -1) {
                  dataJson["appointment_no"] = 'appointment_no' in ele && ele.appointment_no !== '' && ele.appointment_no !== null && ele.appointment_no !== undefined ? ele.appointment_no : ''
                }

                // doctor_name
                if (Object.values(header[0]).indexOf('ทีมแพทย์') != -1) {
                  dataJson["doctor_name"] = 'doctor_name' in ele && ele.doctor_name !== '' && ele.doctor_name !== null && ele.doctor_name !== undefined && ele.doctor_name !== "undefined undefined" ? ele.doctor_name :'-'
                }

                // target_group
                if (Object.values(header[0]).indexOf('กลุ่มเป้าหมาย') != -1) {
                  dataJson["target_group"] = 'target_group' in ele && ele.target_group !== '' && ele.target_group !== null && ele.target_group !== undefined ? ele.target_group : '-'
                }

                // urgency
                if (Object.values(header[0]).indexOf('ความเร่งด่วน') != -1) {
                  dataJson["urgency"] = 'urgency' in ele && ele.urgency !== '' && ele.urgency !== null && ele.urgency !== undefined ? ele.urgency == 1 ? 'เร่งด่วนปกติ' : ele.urgency == 2 ? 'เร่งด่วนปานกลาง' : ele.urgency == 3 ? 'เร่งด่วนมาก'  : '-' :'-'
                }

                // note_doctor
                if (Object.values(header[0]).indexOf('หมายเหตุยกเลิกนัดหมาย') != -1) {
                  dataJson["note"] = 'note' in ele && ele.note !== '' && ele.note !== null && ele.note !== undefined ? ele.note : '-'
                }

                // status
                if (Object.values(header[0]).indexOf('สถานะ') != -1) {
                  dataJson["status"] = 'status' in ele && ele.status !== '' && ele.status !== null && ele.status !== undefined ? ele.status == 1 ? 'รอเยียมบ้าน' : ele.status == 2 ? 'กำลังดำเนินการ' : ele.status == 3 ? 'เสร็จสิ้น' : ele.status == 4 ? 'ยกเลิก' : '-' :'-'
                }

                // note
                if (Object.values(header[0]).indexOf('หมายเหตุยกเลิกนัดหมาย') != -1) {
                  dataJson["note_cancel"] = 'note_cancel' in ele && ele.note_cancel !== '' && ele.note_cancel !== null && ele.note_cancel !== undefined ? ele.note_cancel : '-'
                }

                // form_list
                if (Object.values(header[0]).indexOf('รายละเอียดแบบฟอร์ม') != -1) {
                  dataJson["form_list"] = this.showFormList(ele)
                }
                
                table_body.push(dataJson);
              });

              const dataWS = XLSX.utils.json_to_sheet(title, {
                skipHeader: true,
                origin: "E2",
              });
              XLSX.utils.sheet_add_json(dataWS, header, {
                skipHeader: true,
                origin: "A4",
              });
              XLSX.utils.sheet_add_json(dataWS, table_body, {
                skipHeader: true,
                origin: "A5",
              });


              //set style
              dataWS["E2"].s = {
                font: {
                  bold: true,
                  sz: 12,
                },
              };
              // Set the style for header
              for (let col = 0; col < Object.keys(header[0]).length; col++) {
                const cellRef = XLSX.utils.encode_cell({ r: 3, c: col });
                const cell = dataWS[cellRef];
                if (col == 0) {
                  cell.s = {
                    font: {
                      bold: true,
                    },
                    border: {
                      top: { style: "thin", color: { rgb: "000000" } },
                      bottom: { style: "thin", color: { rgb: "000000" } },
                      left: { style: "thin", color: { rgb: "000000" } },
                    },
                    alignment: {
                      horizontal: "center",
                      vertical: "center",
                      wrapText: true,
                    },
                  };
                } else if (col == Object.keys(header[0]).length - 1) {
                  cell.s = {
                    font: {
                      bold: true,
                    },
                    border: {
                      top: { style: "thin", color: { rgb: "000000" } },
                      bottom: { style: "thin", color: { rgb: "000000" } },
                      right: { style: "thin", color: { rgb: "000000" } },
                    },
                    alignment: {
                      horizontal: "center",
                      vertical: "center",
                      wrapText: true,
                    },
                  };
                } else {
                  cell.s = {
                    font: {
                      bold: true,
                    },
                    border: {
                      top: { style: "thin", color: { rgb: "000000" } },
                      bottom: { style: "thin", color: { rgb: "000000" } },
                    },
                    alignment: {
                      horizontal: "center",
                      vertical: "center",
                      wrapText: true,
                    },
                  };
                }
              }
              //set width column
              dataWS["!cols"] = wscols;



              const wb = XLSX.utils.book_new();

              XLSX.utils.book_append_sheet(wb, dataWS);
              XLSX.writeFile(
                wb,
                `ประวัติการเยี่ยมบ้าน ${sessionStorage.getItem('biz_name')} วันที่ ${this.showDateHeader()}.xlsx`
              );

              setTimeout(() => (
                safe.btn_loading = false,
                safe.dialog = false
              ), 2000)
            }
        })
      } catch (error) {
      console.log('error export' ,error);
      }
    },
  }
}
</script>

<style scoped>
::v-deep .theme--light.v-btn.v-btn--disabled .v-icon, .theme--light.v-btn.v-btn--disabled .v-btn__loading {
    color: #ffffff !important;
}
::v-deep .v-select__selections {
  line-height: 1.8 !important;
}
::v-deep .v-list-item .v-list-item__title {
  line-height: 1.8 !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
</style>